import React from "react";
import { Col, Container, Row, Button } from "react-bootstrap";
import { fadeIn } from "../../Functions/GlobalAnimations";
import { m } from "framer-motion";
import { useNavigate, useParams, useLocation } from "react-router-dom";

const PhotoDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const photoData = location.state?.photoData;

  // Fallback data if no state is passed
  const fallbackData = {
    src: "/images/1_SliderImage_KERA.webp",
    title: "KERA Project Launch",
    description:
      "Official launch ceremony of the Kerala Climate Resilient Agri Value Chain Modernization project",
    date: "2025",
    longDescription:
      "This significant event marked the beginning of a transformative journey for Kerala's agricultural sector. The launch ceremony brought together key stakeholders including government officials, agricultural experts, farmers' representatives, and industry partners. The event showcased the comprehensive vision of KERA to modernize agricultural value chains while building climate resilience. Key highlights included the presentation of project objectives, stakeholder commitments, and the official signing of partnership agreements. This ceremony set the foundation for collaborative efforts towards sustainable agricultural development in Kerala.",
    location: "Thiruvananthapuram, Kerala",
    attendees: "200+ participants",
    category: "Project Launch",
    tags: ["Agriculture", "Climate Resilience", "Modernization", "Kerala"],
  };

  const data = photoData || fallbackData;

  const handleBackToGallery = () => {
    navigate("/photo-gallery");
  };

  return (
    <>
      <m.div className="container mt-[200px]">
        {/* Back Button */}
        <div className="mb-6">
          <Button
            variant="link"
            onClick={handleBackToGallery}
            className="text-[#146084] hover:text-[#0f4a6b] p-0 mb-4 flex items-center gap-2"
          >
            ← Back to Photo Gallery
          </Button>
        </div>

        <Row>
          {/* Image Section */}
          <Col lg={6} md={12} className="mb-6">
            <m.div {...fadeIn} className="relative">
              <img
                src={data.src}
                alt={data.title}
                className="w-full h-[400px] object-cover rounded-lg shadow-lg"
              />
              <div className="absolute top-4 right-4 bg-white bg-opacity-90 px-3 py-1 rounded-full">
                <span className="text-[12px] text-[#146084] font-medium">
                  {data.date}
                </span>
              </div>
            </m.div>
          </Col>

          {/* Content Section */}
          <Col lg={6} md={12}>
            <m.div {...fadeIn} transition={{ delay: 0.2 }}>
              <div className="mb-6">
                <h1 className="font-serif text-[32px] font-medium text-[#146084] -tracking-[1px] mb-4">
                  {data.title}
                </h1>
                <p className="text-[16px] text-[#666] leading-relaxed mb-4">
                  {data.longDescription || data.description}
                </p>
              </div>

              {/* Details Grid */}
              <div className="grid grid-cols-2 gap-4 mb-6">
                <div className="bg-[#f8f9fa] p-4 rounded-lg">
                  <h4 className="text-[14px] font-medium text-[#999] mb-2 uppercase tracking-wide">
                    Location
                  </h4>
                  <p className="text-[16px] text-[#333] font-medium">
                    {data.location || "Kerala, India"}
                  </p>
                </div>
                <div className="bg-[#f8f9fa] p-4 rounded-lg">
                  <h4 className="text-[14px] font-medium text-[#999] mb-2 uppercase tracking-wide">
                    Attendees
                  </h4>
                  <p className="text-[16px] text-[#333] font-medium">
                    {data.attendees || "100+ participants"}
                  </p>
                </div>
                <div className="bg-[#f8f9fa] p-4 rounded-lg">
                  <h4 className="text-[14px] font-medium text-[#999] mb-2 uppercase tracking-wide">
                    Category
                  </h4>
                  <p className="text-[16px] text-[#333] font-medium">
                    {data.category || "Event"}
                  </p>
                </div>
                <div className="bg-[#f8f9fa] p-4 rounded-lg">
                  <h4 className="text-[14px] font-medium text-[#999] mb-2 uppercase tracking-wide">
                    Date
                  </h4>
                  <p className="text-[16px] text-[#333] font-medium">
                    {data.date}
                  </p>
                </div>
              </div>

              {/* Tags */}
              {data.tags && (
                <div className="mb-6">
                  <h4 className="text-[14px] font-medium text-[#999] mb-3 uppercase tracking-wide">
                    Tags
                  </h4>
                  <div className="flex flex-wrap gap-2">
                    {data.tags.map((tag, index) => (
                      <span
                        key={index}
                        className="bg-[#146084] text-white px-3 py-1 rounded-full text-[12px] font-medium"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {/* Action Buttons */}
              <div className="flex gap-4">
                <Button
                  variant="outline-primary"
                  className="border-[#146084] text-[#146084] hover:bg-[#146084] hover:text-white transition-colors duration-200"
                >
                  Download Image
                </Button>
                <Button
                  variant="outline-secondary"
                  className="border-[#666] text-[#666] hover:bg-[#666] hover:text-white transition-colors duration-200"
                >
                  Share
                </Button>
              </div>
            </m.div>
          </Col>
        </Row>
      </m.div>
    </>
  );
};

export default PhotoDetails;
